// @generated by protoc-gen-es v2.5.1 with parameter "target=ts,json_types=true"
// @generated from file conversions_developers/v1/token.proto (package conversions_developers.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file conversions_developers/v1/token.proto.
 */
export const file_conversions_developers_v1_token: GenFile =
	/*@__PURE__*/
	fileDesc(
		"CiVjb252ZXJzaW9uc19kZXZlbG9wZXJzL3YxL3Rva2VuLnByb3RvEhljb252ZXJzaW9uc19kZXZlbG9wZXJzLnYxIjIKBlNlY3JldBIRCgljbGllbnRfaWQYASABKAkSFQoNY2xpZW50X3NlY3JldBgCIAEoCSK1AgoMVXNlckFwaVRva2VuEgoKAmlkGAEgASgJEgwKBG5hbWUYAiABKAkSEwoLZGVzY3JpcHRpb24YAyABKAkSDgoGb3JnX2lkGAQgASgJEjEKBnNlY3JldBgFIAEoCzIhLmNvbnZlcnNpb25zX2RldmVsb3BlcnMudjEuU2VjcmV0Eg8KB3VzZXJfaWQYBiABKAkSLgoKY3JlYXRlZF9hdBgHIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLgoKdXBkYXRlZF9hdBgIIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASMwoKZGVsZXRlZF9hdBgJIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIAIgBAUINCgtfZGVsZXRlZF9hdGIGcHJvdG8z",
		[file_google_protobuf_timestamp],
	);

/**
 * represents the actual API credentials used to
 * fetch JWTs
 *
 * @generated from message conversions_developers.v1.Secret
 */
export type Secret = Message<"conversions_developers.v1.Secret"> & {
	/**
	 * this is the client id of the secret
	 *
	 * @generated from field: string client_id = 1;
	 */
	clientId: string;

	/**
	 * this is the client secret
	 *
	 * @generated from field: string client_secret = 2;
	 */
	clientSecret: string;
};

/**
 * represents the actual API credentials used to
 * fetch JWTs
 *
 * @generated from message conversions_developers.v1.Secret
 */
export type SecretJson = {
	/**
	 * this is the client id of the secret
	 *
	 * @generated from field: string client_id = 1;
	 */
	clientId?: string;

	/**
	 * this is the client secret
	 *
	 * @generated from field: string client_secret = 2;
	 */
	clientSecret?: string;
};

/**
 * Describes the message conversions_developers.v1.Secret.
 * Use `create(SecretSchema)` to create a new message.
 */
export const SecretSchema: GenMessage<Secret, { jsonType: SecretJson }> = /*@__PURE__*/ messageDesc(file_conversions_developers_v1_token, 0);

/**
 * User API token is a credential that is tied to a user account.
 *
 * @generated from message conversions_developers.v1.UserApiToken
 */
export type UserApiToken = Message<"conversions_developers.v1.UserApiToken"> & {
	/**
	 * id of the token
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * name of the token, must be unique for the scope at which it was generated
	 *
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * optional description of the API token
	 *
	 * @generated from field: string description = 3;
	 */
	description: string;

	/**
	 * id of the org to which the token belongs.
	 *
	 * @generated from field: string org_id = 4;
	 */
	orgId: string;

	/**
	 * api secret -- will be null unless the secret is explicitly revealed
	 *
	 * @generated from field: conversions_developers.v1.Secret secret = 5;
	 */
	secret?: Secret;

	/**
	 * the id of the user account to which this API token belongs
	 *
	 * @generated from field: string user_id = 6;
	 */
	userId: string;

	/**
	 * when the credential was created
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: Timestamp;

	/**
	 * when the credential was updated
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: Timestamp;

	/**
	 * when the credential was deleted
	 *
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 9;
	 */
	deletedAt?: Timestamp;
};

/**
 * User API token is a credential that is tied to a user account.
 *
 * @generated from message conversions_developers.v1.UserApiToken
 */
export type UserApiTokenJson = {
	/**
	 * id of the token
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * name of the token, must be unique for the scope at which it was generated
	 *
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * optional description of the API token
	 *
	 * @generated from field: string description = 3;
	 */
	description?: string;

	/**
	 * id of the org to which the token belongs.
	 *
	 * @generated from field: string org_id = 4;
	 */
	orgId?: string;

	/**
	 * api secret -- will be null unless the secret is explicitly revealed
	 *
	 * @generated from field: conversions_developers.v1.Secret secret = 5;
	 */
	secret?: SecretJson;

	/**
	 * the id of the user account to which this API token belongs
	 *
	 * @generated from field: string user_id = 6;
	 */
	userId?: string;

	/**
	 * when the credential was created
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: TimestampJson;

	/**
	 * when the credential was updated
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: TimestampJson;

	/**
	 * when the credential was deleted
	 *
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 9;
	 */
	deletedAt?: TimestampJson;
};

/**
 * Describes the message conversions_developers.v1.UserApiToken.
 * Use `create(UserApiTokenSchema)` to create a new message.
 */
export const UserApiTokenSchema: GenMessage<UserApiToken, { jsonType: UserApiTokenJson }> = /*@__PURE__*/ messageDesc(file_conversions_developers_v1_token, 1);
